export default function CGU() {
  return (
    <div className="page">
      <div className="card">
        <h1>Conditions d’utilisation</h1>

        <p>
          L’utilisation de ce site implique l’acceptation pleine et entière des
          conditions générales ci-dessous.
        </p>

        <p>
          Les outils proposés fournissent des estimations à titre indicatif et
          ne remplacent en aucun cas un avis professionnel.
        </p>

        <p>
          L’éditeur se réserve le droit de modifier les contenus à tout moment.
        </p>
      </div>
    </div>
  );
}
